// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { getDisplayProductPricesPolicy } from "@store/Framework/Store/Context/ContextSelectors";
import { getIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextSelectors";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

/* Store Custom Code - Start */
export const getIsMobileSalesAccount = (state: ApplicationState) => {
    const settings = getSettingsCollection(state);
    const isMobileSalesEnabled = settings.mobileSalesSettings.isMobileSalesEnabled;
    if (!isMobileSalesEnabled) {
        return false;
    }
    const currentAccount = getCurrentAccountState(state).value;
    return getBooleanProperty(currentAccount?.properties?.isMobileSalesAccount);
};
/* Store Custom Code - End */

export const canUserSeePrices = (state: ApplicationState) => {
    const isAuthenticated = getIsAuthenticated(state);
    const currentAccount = getCurrentAccountState(state).value;
    const displayProductPricesPolicy = getDisplayProductPricesPolicy(state);

    if (!displayProductPricesPolicy) {
        return true;
    }

    /* Store Custom Code - Start */
    const isMobileSalesAccount = getBooleanProperty(currentAccount?.properties?.isMobileSalesAccount);
    const canSeePricesPolicy = getBooleanProperty(currentAccount?.properties?.canSeePricesPolicy);
    const isAdministrator = currentAccount?.role === "Administrator";
    if (isAuthenticated) {
        return canSeePricesPolicy || (isAdministrator && !isMobileSalesAccount);
    }
    return true;
};
/* Store Custom Code - End */
